import rnCore from 'rhino/src/core/core.module';
import * as rnUnsubscribe from './unsubscribe.service';

export default angular.module('rhino.components.unsubscribe', [
  rnCore
])
.service(rnUnsubscribe.name, rnUnsubscribe.default)
.name;



// WEBPACK FOOTER //
// ../~/@printos/rhino/src/components/unsubscribe/unsubscribe.module.js